module.exports = __webpack_public_path__ + "img/circle-cross-black-used.4c558fcb.svg";